.copy-to-clipboard-content {
  align-items: var(--copy-to-clipboard-align-items, unset);
}

.btn-copy-to-clipboard {
  align-self: center;
  padding: var(--btn-padding, 0 0 0 calc(var(--spacer) * 1.5));
}
:host([showIconOnHover]) {
  .btn-copy-to-clipboard {
    visibility: hidden;
  }

  .copy-to-clipboard-content {
    &:hover {
      .btn-copy-to-clipboard {
        visibility: visible !important;
      }
    }
  }
}
